import "../App.css";
// import Header from "../component/header/index.jsx";
import Footer from "../component/footer/index.jsx";

function CookiePolicy() {
  return (
    <>
      <div className="App">
        <section className="creative-sec privacy">
          <div className="container-1280 ">
            <div className="row">
              <div className="col-lg-12 pp-txt-d">
                <h2 className="white-color lg-txt col-lg-3">Cookie</h2>
                <img
                  className="col-lg-3"
                  src={require("../Assets/img/cookie-img.png")}
                  alt=""
                />
                <h2 className="white-color lg-txt col-lg-3">Policy</h2>
              </div>

              <div className="pp-txt-m">
                <h2 className="white-color">Cookie Policy</h2>
              </div>
            </div>
          </div>
        </section>
        <section className="privacy-text">
          <div className="container-1280">
            <p>
              Welcome to KingsCharts.io. This website is owned and operated by
              ZELTA TECH PRIVATE LIMITED, B-29-30, B-39-40, RICO Industrial
              Area, 22 Godown Industrial Area, Jaipur, Rajasthan -302001 India.
              By visiting our website and using the information, resources,
              services, products, and tools we provide, you understand and agree
              to accept and adhere to the terms and conditions stated in this
              policy (hereafter referred to as the 'User Agreement'), as well as
              the terms and conditions stated in our Privacy Policy (for more
              information, please see the Privacy Policy section below).
            </p>
            <br />
            <p>
              The Privacy Policy oversees the ways in which KingsCharts.io
              gathers, uses, maintains, and discloses information collected from
              users (singular “a user”) of the https://kingscharts.io/ website
              (“Site”). This privacy policy is applicable to the Site and all
              the products and services offered by King’s Charts.
            </p>
            <br />
            <h3>1. PERSONAL IDENTIFICATION INFORMATION</h3>
            <p>
              Personal identification information may be collected from Users in
              a variety of ways, including, but not limited to, when Users visit
              our site, register on the site, place an order, and in connection
              with other activities, services, features, or resources made
              available on our Site. Users may be asked for their name, email
              address, mailing address, and phone number, as appropriate.
              However, users may visit our Site anonymously. We will only
              collect personal identification information from Users if they
              voluntarily provide it to us. Users can always refuse to provide
              personal identification information, but doing so may prevent them
              from participating in certain Site-related activities.
            </p>
            <br />
            <h3>2. NON-PERSONAL IDENTIFICATION INFORMATION</h3>
            <p>
              When Users interact with our Site, we may collect non-personal
              identification information about them. Non-personal identification
              information may include the browser name, computer type, and
              technical information about Users' means of connection to our
              Site, such as the operating system and Internet service providers
              used, among other similar bodies of information.
            </p>
            <br />
            <h3>3. WEB BROWSER COOKIES</h3>
            <p>
              “Cookies" may be used on our site to improve the user experience.
              Cookies are placed on a user's hard drive by their web browser for
              record-keeping and sometimes to track information about them.
              Users can configure their web browser to refuse cookies or to
              notify them when cookies are sent. If they do, keep in mind that
              some parts of the Site may not work properly.
            </p>
            <br />
            <h3>4. Usage of Collected Information</h3>
            <p>
              King’s Charts may collect and use personal information from Users
              for the following reasons: To enhance customer service - The
              information you provide allows us to respond to your customer
              service and support requests more efficiently.
            </p>
            <br />
          </div>
        </section>
      </div>
      <Footer />
    </>
  );
}

export default CookiePolicy;
